import { Canceler } from 'axios';
import * as React from 'react';
import API from 'src/services/api';

import { Creating } from './sections/Creating';
import { Managing } from './sections/Managing';
import { UserManaging } from './sections/UserManaging';

const sections = [Creating, Managing, UserManaging];

interface ITutorialState {
  additional: string;
}

class Tutorial extends React.Component<null, ITutorialState> {
  state: ITutorialState = {
    additional: '',
  };
  canceler: Canceler | null = null;

  async componentDidMount() {
    const { getData, cancel } = API.CONTENT.additional();
    this.canceler = cancel;
    const data = await getData();
    this.setState({
      additional: data,
    });
  }

  componentWillUnmount() {
    if (this.canceler) {
      this.canceler();
    }
  }

  render() {
    const { additional } = this.state;
    return (
      <div className="max-w-lg mx-auto my-16">
        {additional && (
          <div
            className="accordion-content bg-grey px-6 py-4"
            dangerouslySetInnerHTML={{ __html: additional }}
          />
        )}
        {sections.map((Section, index) => (
          <Section key={index} index={index + 1} />
        ))}
      </div>
    );
  }
}

export default Tutorial;



// WEBPACK FOOTER //
// ./src/views/Tutorial/Tutorial.tsx